import React, { useMemo } from 'react';
import Head from 'next/head';
import ImageGallery from 'react-image-gallery';
import classNames from 'classnames';

import { getLanguageId } from '@helpers/language';
import { Button, Viewer360 } from '@components';
import styles from './BuildCustomization.module.scss';

export default function BuildImage({ locale, imgCode, productDetail, darkMode }) {
  const imgURL = imgCode ? `/api/static/media/byfile/Products/${imgCode}/Studio/1_N_N_N_I_640x640.png` : null;
  const GalleryCheck = true;

  const images = useMemo(() => {
    if (!productDetail) return [];
    const gallery = productDetail.ProductGallery.filter((g) => g.Description === 'B&Q')
      .map((item) => {
        const galleryItems = item.GalleryItems.map((galleryItem) => (
          galleryItem.ProductGalleryContent.filter((x) => parseInt(x.Language) === getLanguageId(locale))
            .map((content) => ({
              fileNameUrl: content.FileNameUrl,
              thumbnailUrl: content.ThumbnailUrl,
              sequence: galleryItem.Sequence,
            }))
            .filter(x => !x.fileNameUrl.includes('sirv'))
        ));
        return galleryItems.flat();
      }).flat().map((item) => ({
        original: `/api/static/media/byfile${item.fileNameUrl}`,
        thumbnail: `/api/static/media/byfile${item.thumbnailUrl || item.fileNameUrl}`,
        originalClass: styles.manifestGalleryImage,
        sequence: item.sequence,
      }));

    const gallery360 = productDetail.ProductGallery.filter((g) => g.Description === 'B&Q')
      .map((item) => {
        const galleryItems = item.GalleryItems.map((galleryItem) => (
          galleryItem.ProductGalleryContent.filter((x) => parseInt(x.Language) === getLanguageId(locale))
            .map((content) => ({
              fileNameUrl: content.FileNameUrl,
              thumbnailUrl: content.ThumbnailUrl,
              sequence: galleryItem.Sequence,
            }))
        ));
        return galleryItems.flat();
      }).flat().filter((x) => x.fileNameUrl?.includes("sirv") && x.fileNameUrl?.includes("spin")).map((item) => ({
        thumbnail: `/api/static/media/byfile${item.thumbnailUrl}`,
        originalClass: styles.manifestGalleryImage,
        sequence: item.sequence,
        renderItem: () => (
          <div
            className={classNames(
              styles.Wrapper,
              darkMode ? styles.DarkMode : null,
            )}
          >
            <div
              className="Sirv"
              id="srv"
              data-options="thumbnails.type: auto; arrows: false;"
            >
              <div data-src={item.fileNameUrl}></div>
            </div>
          </div>
        ),
      }));

    return [...gallery, ...gallery360].sort((a, b) => a.sequence - b.sequence);
  }, [productDetail]);

  return (
    <div className={styles.manifestImage}>
      {images.length > 0 && GalleryCheck  ? (
        <ImageGallery items={images} showBullets />
      ) : (
        <>{imgURL && <img src={imgURL} />}</>
      )}
    </div>
  );
}

